<template>
  <v-app>
    <top-nav-bar v-if="isAuthenticated" @openCart="drawer=true" />

    <v-navigation-drawer
      v-model="drawer"
      app
      right
      temporary
      hideOverlay
      width="400"
    >
      <the-cart @close="drawer=false" />
    </v-navigation-drawer>

    <v-main
      id="main-content"
    >
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import axios from 'axios';

import TopNavBar from './components/TopNavBar.vue';
import { mapGetters } from 'vuex';
import TheCart from '@/components/TheCart.vue';

export default {
  name: 'App',
  components: {
    TopNavBar,
    TheCart
  },
  data: function () {
    return {
      drawer: false
    };
  },
  computed: {
    ...mapGetters([
      'isAuthenticated'
    ])
  },
  created: function () {
    axios.interceptors.response.use((response) => {
      return response;
    },
    (err) => {
      return new Promise((resolve, reject) => {
        if ((err?.status === 401 || err.response?.status === 401) && err.config && !err.config.__isRetryRequest) {
          // if you ever get an unauthorized, logout the user
          this.$store.dispatch('logout')
            .then(() => {
              this.$router.push('/login');
            });
        }
        throw err;
      });
    });
  },
  onIdle: function () {
    this.$store.dispatch('logout')
      .then(() => {
        this.$router.push({
          path: '/login',
          query: {
            redirect: this.$route.fullPath
          }
        });
      });
  }
};
</script>
